var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormImage" } }, [
    _c("div", { class: "form-image form-image-align-" + _vm.align }, [
      _c("img", {
        style: { width: _vm.imageWidth + "px", height: _vm.imageHeight + "px" },
        attrs: { src: _vm.asset },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }